import { isH5SessionExpired, notifyH5SessionExpired } from './session-expiry'

const API_BASE = import.meta.env.VITE_API_BASE || ''

export function apiUrl(path: string) { return `${API_BASE}${path}` }

export class ApiError extends Error {
  constructor(public status: number, message: string, public code?: number, public data?: unknown) { super(message) }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(apiUrl(path), {
    credentials: 'include',
    ...init,
    headers: { ...(init.body ? { 'Content-Type': 'application/json' } : {}), ...(init.headers || {}) }
  })
  const payload = await response.json().catch(() => null)
  if (isH5SessionExpired(response.status, payload?.code)) notifyH5SessionExpired()
  if (!response.ok || (payload && payload.code && payload.code !== 200)) {
    throw new ApiError(response.status, payload?.message || '网络开小差了，请稍后再试', payload?.code, payload?.data)
  }
  return payload?.data as T
}
